import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

/**
 * A native button styled to look like a link.
 * Use this instead of <Button appearance="link" onClick={...}> to avoid
 * Atlaskit token dependency for link color rendering.
 */
const ButtonLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: ${token('color.link', '#0C66E4')};
  font-size: inherit;
  font-family: inherit;
  text-decoration: none;
  display: inline;

  &:hover {
    color: ${token('color.link.pressed', '#0055CC')};
    text-decoration: underline;
  }

  &:disabled {
    color: ${token('color.text.disabled', '#8993A5')};
    cursor: not-allowed;
  }
`;

export default ButtonLink;

/**
 * A styled anchor that looks like a link (no button chrome).
 * Use this instead of <LinkButton appearance="link" href="..."> which is not supported.
 */
export const AnchorLink = styled.a`
  color: ${token('color.link', '#0C66E4')};
  text-decoration: none;
  font-size: inherit;
  font-family: inherit;

  &:hover {
    color: ${token('color.link.pressed', '#0055CC')};
    text-decoration: underline;
  }
`;
